export function rupiah(n) {
  const v = Math.round(Number(n) || 0);
  return "Rp " + v.toLocaleString("id-ID");
}

export function rupiahShort(n) {
  const v = Math.round(Number(n) || 0);
  if (v >= 1_000_000_000) return "Rp " + (v / 1_000_000_000).toFixed(1).replace(".0", "") + " M";
  if (v >= 1_000_000) return "Rp " + (v / 1_000_000).toFixed(1).replace(".0", "") + " jt";
  if (v >= 1_000) return "Rp " + Math.round(v / 1000) + " rb";
  return "Rp " + v.toLocaleString("id-ID");
}

const JKT = "Asia/Jakarta";

export function fmtDate(iso) {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleDateString("id-ID", {
      day: "2-digit", month: "short", year: "numeric", timeZone: JKT,
    });
  } catch { return iso; }
}

export function fmtDateTime(iso) {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleString("id-ID", {
      day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", timeZone: JKT,
    });
  } catch { return iso; }
}

export function daysSince(iso) {
  if (!iso) return 999;
  return Math.floor((Date.now() - new Date(iso).getTime()) / 86400000);
}

export function initials(name) {
  if (!name) return "?";
  return name.split(" ").map((s) => s[0]).slice(0, 2).join("").toUpperCase();
}

export function slug(s) {
  return (s || "").toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "");
}
